import { createContext, useContext } from 'react'
import { useValidacaoCaricatura } from '../hooks/useValidacaoCaricatura'

export const ValidacaoCaricaturaContext = createContext()

export const ValidacaoCaricaturaProvider = ({ children }) => {
  const { query, setFormValues, onFilter } = useValidacaoCaricatura()

  return (
    <ValidacaoCaricaturaContext.Provider
      value={{
        query,
        setFormValues,
        onFilter,
      }}
    >
      {children}
    </ValidacaoCaricaturaContext.Provider>
  )
}

export const useValidacaoCaricaturaContext = () => {
  return useContext(ValidacaoCaricaturaContext)
}
